import { useEffect, useRef } from "react";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl:
    "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png",
  iconUrl:
    "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png",
  shadowUrl:
    "https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png",
});

export default function MapView({
  devices = [],
  selected,
  setSelected,
  sidebarOpen
}) {
  const mapRef = useRef(null);

  const validDevices = devices
    .map(d => ({
      ...d,
      lat: Number(d.lat),
      lng: Number(d.lng)
    }))
    .filter(d => !isNaN(d.lat) && !isNaN(d.lng));

  const center =
    validDevices.length > 0
      ? [validDevices[0].lat, validDevices[0].lng]
      : [63.84426, 23.13756];

  // zoom selected
  useEffect(() => {
    if (!mapRef.current) return;
    if (!selected) return;
    if (selected.lat == null || selected.lng == null) return;

    mapRef.current.setView(
      [Number(selected.lat), Number(selected.lng)],
      14
    );
  }, [selected]);

  // 🔥 FIX: sidebar open/close → redraw map
  useEffect(() => {
    if (!mapRef.current) return;

    const t = setTimeout(() => {
      mapRef.current.invalidateSize(true);
    }, 300);

    return () => clearTimeout(t);

  }, [sidebarOpen]);

  return (
    <MapContainer
      center={center}
      zoom={12}
      style={{ height: "100%", width: "100%" }}
      whenCreated={map => (mapRef.current = map)}
    >
      <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />

      {validDevices.map(d => (
        <Marker
          key={d.id}
          position={[d.lat, d.lng]}
          eventHandlers={{ click: () => setSelected(d) }}
        >
          <Popup>
            <b>{d.name}</b>
            <br />
            {typeof d.temp === "number" && !isNaN(d.temp) && (
              <>🌡 {d.temp.toFixed(1)}°C</>
            )}
            {typeof d.water === "number" && !isNaN(d.water) && (
              <>
                <br />
                💧 {d.water.toFixed(1)}°C
              </>
            )}
          </Popup>
        </Marker>
      ))}
    </MapContainer>
  );
}